import { makeStyles } from '@material-ui/core'
import { COLOR, FONT, MARGIN, SIZE } from 'constants/styles'

export default makeStyles({
  root: {
    margin: MARGIN.CONTENT,
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: COLOR.CONTENT_BACKGROUND,
  },
  grid_list: {
    width: '100%',
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
  },
  tile_bar: {
    fontFamily: FONT.GOTHIC,
    fontSize: SIZE.PHOTO_TITLE,
    color: COLOR.PHOTO_TITLE,
  },
})
